export default function generateErrorMarkup(errors: any, name: string) {

  let errMsgText = errors[name] ? errors[name].message : null;
  // console.log(errors);

  // custom error message because I can't specify one with a custom validate function
  // if (name === 'zipPostal' && errMsgText === '')
  //   errMsgText = 'Invalid format';

  const errMsg = errMsgText ? (
    <ul className='parsley-errors-list filled' id={name + '-errors'}>
      <li>{errMsgText}</li>
    </ul>
  ) : null;

  return errMsg;
}
